module.exports = __webpack_public_path__ + "static/img/chejia_car_ex5.789f097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/VehicleInformation/chejia_car_ex5.png
// module id = kYPS
// module chunks = 19